import React from 'react';
import './DayNavigation.css';

const DayNavigation = ({ selectedDate, onDateChange, earliestDate }) => {
  // Helper function to format dates
  const formatDate = (date) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    
    const month = months[date.getMonth()];
    const dayNum = date.getDate();
    const dayName = days[date.getDay()];
    
    return { month, dayNum, dayName };
  };

  // Check if selected date is today
  const isToday = () => {
    const today = new Date();
    return selectedDate.toDateString() === today.toDateString();
  };

  // Check if we can navigate backward
  const canGoBack = () => {
    return selectedDate > earliestDate;
  };

  // Check if we can navigate forward (can't go past today)
  const canGoForward = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);
    return selected < today;
  };

  // Navigation handlers
  const handlePreviousDay = () => {
    if (canGoBack()) {
      const newDate = new Date(selectedDate);
      newDate.setDate(newDate.getDate() - 1);
      onDateChange(newDate);
    }
  };

  const handleNextDay = () => {
    if (canGoForward()) {
      const newDate = new Date(selectedDate);
      newDate.setDate(newDate.getDate() + 1);
      onDateChange(newDate);
    }
  };

  const { month, dayNum, dayName } = formatDate(selectedDate);

  return (
    <div className="day-navigation">
      {isToday() ? (
        // Today layout - two lines
        <>
          <div className="today-label">Today</div>
          <div className="date-with-arrows">
            <button 
              className={`nav-arrow left ${!canGoBack() ? 'disabled' : ''}`}
              onClick={handlePreviousDay}
              disabled={!canGoBack()}
              aria-label="Previous day"
            >
              ◀
            </button>
            <span className="date-text">{dayName}, {month} {dayNum}</span>
            <button 
              className={`nav-arrow right ${!canGoForward() ? 'disabled' : ''}`}
              onClick={handleNextDay}
              disabled={!canGoForward()}
              aria-label="Next day"
            >
              ▶
            </button>
          </div>
        </>
      ) : (
        // Other days - single line
        <div className="date-with-arrows">
          <button 
            className={`nav-arrow left ${!canGoBack() ? 'disabled' : ''}`}
            onClick={handlePreviousDay}
            disabled={!canGoBack()}
            aria-label="Previous day"
            >
            ◀
          </button>
          <span className="date-text">{dayName}, {month} {dayNum}</span>
          <button 
            className={`nav-arrow right ${!canGoForward() ? 'disabled' : ''}`}
            onClick={handleNextDay}
            disabled={!canGoForward()}
            aria-label="Next day"
          >
            ▶
          </button>
        </div>
      )}
    </div>
  );
};

export default DayNavigation;